import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TextField, Link, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { paths } from "frontend/src/pages/paths";
import { CircleLogo } from "frontend/src/ui/circle-logo";
import { useForgotPassword } from "frontend/src/features/reset-password";
import { GuestUserLayout } from "frontend/src/pages/layouts/guest-user-layout";
import { locales } from "frontend/src/domain/localization/i18n";
import { MultilineHelperText } from "frontend/src/ui/multiline-helper-text";
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    error: {
        color: "red",
    },
}); });
var Page = function () {
    var _a;
    var classes = useStyles();
    var t = useTranslation(locales.namespaces.guest).t;
    var t2 = useTranslation(locales.namespaces.shared).t;
    var _b = useForgotPassword(), email = _b.email, submit = _b.submit, errors = _b.errors, pending = _b.pending, success = _b.success;
    var onChange = function (evt) {
        return email.set(evt.target.value);
    };
    var onSubmit = function (evt) {
        evt.preventDefault();
        submit();
    };
    return (React.createElement(Box, null,
        React.createElement("div", { className: classes.paper },
            React.createElement(CircleLogo, { className: classes.avatar }),
            React.createElement(Typography, { component: "h1", variant: "h5" }, t("pages.forgotPassword.header")),
            success ? (React.createElement(Box, { mt: 2 },
                React.createElement(Typography, null, t("pages.forgotPassword.successMessage")))) : (React.createElement("form", { className: classes.form, noValidate: true, onSubmit: onSubmit },
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, type: "email", fullWidth: true, label: t("pages.forgotPassword.email"), autoFocus: true, disabled: pending, error: !!errors.email, helperText: React.createElement(MultilineHelperText, { texts: (_a = errors.email) !== null && _a !== void 0 ? _a : [] }), value: email.value, onChange: onChange }),
                errors.unknown && (React.createElement(Box, null,
                    React.createElement(Typography, { className: classes.error, variant: "caption" }, t2("errors.unknown")))),
                React.createElement(ButtonLoader, { isLoading: pending, type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, t("pages.forgotPassword.submit")))),
            React.createElement(Box, { ml: "auto" },
                React.createElement(Link, { component: RouterLink, to: paths.login(), variant: "body2" }, t("pages.forgotPassword.back")))),
        React.createElement(Box, { mt: 4 },
            React.createElement(Typography, { variant: "body2", color: "textSecondary", align: "center" },
                "Copyright © ",
                React.createElement(Link, { color: "inherit", href: "https://imstream.net/" }, "imstream"),
                " ",
                new Date().getFullYear(),
                "."))));
};
export var ForgotPasswordPage = function () { return (React.createElement(GuestUserLayout, null,
    React.createElement(Page, null))); };
